import { registerConsent } from '@/util/consent'

class GTMTracking {
  constructor ({ criteoConfig, gtmConfigId }) {
    this.gtmConfigId = gtmConfigId
    this.criteoConfig = criteoConfig
    this.loaded = false
    registerConsent({ vendor: 'GOOGLE', onAdd: this.onAdd.bind(this) })
  }

  onAdd () {
    this.load(this.gtmConfigId)
  }

  load (gtmConfigId) {
    if (this.loaded) { return }

    // eslint-disable-next-line
    (function (w, d, s, l, i) { w[l] = w[l] || []; w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' }); const f = d.getElementsByTagName(s)[0]; const j = d.createElement(s); const dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f) })(window, document, 'script', 'dataLayer', gtmConfigId)
    this.loaded = true
    if (!global.window.dataLayer) {
      global.window.dataLayer = []
    }

    if (this.criteoConfig) {
      global.window.dataLayer.push(this.criteoConfig)
    }
  }
}

global.window.GTMTracking = GTMTracking
